import React, { useCallback, useMemo, useRef } from 'react'

import { EventCard } from 'Components/Blocks'
import { Loader, Row } from 'Components/UI'
import { EventItem } from 'Types/emajinAPI'

import { usePaginatedFetch } from 'Hooks'

import APIService from 'Services/API'

import { Container } from './styles'
import { getNextEventsByState } from './utils'

function Gallery() {
  const ref = useRef(null)

  const fetchPage = useCallback(async () => {
    const res = await APIService.getEvents({
      offset: 0,
    })
    return res.events ?? []
  }, [])

  const {
    items: events,
    loading,
    error,
  } = usePaginatedFetch<EventItem>({
    fetchPage,
  })

  const upcomingEvents = useMemo(() => getNextEventsByState(events), [events])

  if (error || !upcomingEvents || !upcomingEvents.length) return null

  return (
    <Container
      alignItems={['center', 'center', 'center', 'center', 'unset']}
      flexDirection={['column', 'column', 'column', 'column', 'row']}
      ref={ref}
    >
      {loading ? (
        <Row alignCenter fullWidth height={624} justifyCenter>
          <Loader size={32} />
        </Row>
      ) : (
        upcomingEvents.map(item => <EventCard data={item} key={item.id} />)
      )}
    </Container>
  )
}

export default Gallery
